import * as React from 'react';
import {Checkbox, view} from '@sail/ui';

export const Disabled = () => {
  return (
    <view.div
      css={{
        layout: 'column',
      }}
    >
      <Checkbox label="This Checkbox is disabled." defaultChecked disabled />
      <Checkbox disabled invalid label="This invalid Checkbox is disabled." />
    </view.div>
  );
};
